<template>
  <el-dialog
          title="批量开通AI雷达和名片"
          :visible.sync="dialogVisible"
          @close="$emit('update:visible',false)"
          :close-on-click-modal="false"
  >
    <div class="dialog_conwrap">
      <el-transfer v-model="value" :data="dataList" :titles="['未开通成员', '已选择成员']" @change="handleChange">
        <el-button class="transfer-footer" slot="right-footer" size="small" @click="value=[]">清空</el-button>
      </el-transfer>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取消</el-button>
      <el-button type="primary" @click="saveSubmitFn" size="small">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "batchOpenDialog",
    props: ["visible"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dataList: [],
        value: [],
        dialogVisible: this.visible,
        raderList: []
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        let params = {
          name: '',
          depart_id: ''
        };
        this.axios
            .post(api.radar_un_access, params)
            .then(response => {
              if (response.data.code == 0) {
                let dataList = [];
                for (let i in response.data.list) {
                  let dataObj = {};
                  dataObj.key = i
                  dataObj.label = response.data.list[i].name
                  dataList.push(dataObj)
                }
                this.dataList = dataList
                this.raderList = response.data.list
              } else {
              }
            })
            .catch(response => {
            });
      },
      handleChange(value, direction, movedKeys) {
        if(direction==='right'){

        }else{

        }
      },
      saveSubmitFn() {
        if (this.value.length !== 0) {
          // dataList
          let id = [];
          for(let i in this.value){
            id.push(this.raderList[this.value[i]].id);
          };
          let params ={
            open_status: 1,
            em_id:id
          }
          this.axios
              .post(api.radar_ai_open, params)
              .then(response => {
                if (response.data.code == 0) {
                  this.$message({
                    message: '开通成功',
                  });
                  this.$emit('submitFn');
                  this.dialogVisible = false;
                }
              })
              .catch(response => {
              });
        } else {
          this.$message.error('请选择成员');
        }
      }
    }
  };
</script>



